import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class Impuesto extends FormComponent {

  componentDidMount() {
    const options = [{ 'Label': "Si", 'Value': 'Si' },{ 'Label': "No", 'Value': 'No' }]
    const optionsLoFe = [{ 'Label': 'Federal', 'Value': 'Federal' }, { 'Label': 'Local', 'Value': 'Local' }]
    this.FormConfig(
      { defaultUrl: 'impuesto/one', saveUrl: 'impuesto/save', backUrl: '/Catalogo/Impuestos' },
      new Form([
        Form.Field('text', 'impuesto_clave', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'impuesto_nombre', 'Nombre', '', [Validators.required], 8),
        Form.Field('select', 'impuesto_retencion', 'Retencion', '', [Validators.required], 4, options),
        Form.Field('select', 'impuesto_traslado', 'Traslado', '', [Validators.required], 4, options),
        Form.Field('select', 'impuesto_local_federal', 'Local o Federal', '', [Validators.required], 4, optionsLoFe),
        Form.Field('text', 'impuesto_entidad', 'Entidad', '', [], 12),
      ], ['Guardar'], 'Impuesto'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Impuesto)
